let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("px9BB")).then(() => parcelRequire('2wqpp'));